import $ from 'jquery';
// import { breakpoints } from './_site';

let baseClass = 'mobile-floater';
let activeClass = baseClass + '--active';
let openClass = baseClass + '--opened';

export const toggleDisplay = ($el) => {
    let $component = $el.closest('.mobile-floater');

    if ($component.length) {
        $component.toggleClass(openClass);

        if ($component.hasClass(openClass)) {
            setTimeout(function() {
                $component.css('top', 0);
            }, 250);
            $('body').addClass('mobile-floater-active');
        } else {
            $component.css('top', 'auto');
            $('body').removeClass('mobile-floater-active');
        }
    }
};
export const activateMobileFloater = () => {
    let $target = $('.mobile-floater');

    if ($target.length) {
        $target.addClass(activeClass);
    }
};
export const deactivateMobileFloater = (target) => {
    let $target = $('.mobile-floater');

    if ($target.length) {
        $target.removeClass(activeClass);
    }
};
export const binds = () => {
    $('#wrapper').on(
        'click.mobile-floater',
        '[data-toggle-mobile-floater]',
        function(event) {
            toggleDisplay($(this));
        }
    );
};
